/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'cart': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: `<defs><clipPath id="svgicon_cart_a"><path pid="0" d="M0 0h44v44H0z"/></clipPath></defs><g clip-path="url(#svgicon_cart_a)"><g transform="translate(-857.733 -1817.547)" _fill="none" _stroke="currentColor"><path pid="1" d="M857.733 1822.545h4.39l8.487 23.228M867.05 1827.493h34.048l-2.345 12.591-26.576 2.015" stroke-miterlimit="10"/><path pid="2" d="M871.563 1842.146h0"/><circle pid="3" cx="5.249" cy="5.249" r="5.249" transform="translate(869.047 1844.547)" stroke-miterlimit="10"/><circle pid="4" cx="5.249" cy="5.249" r="5.249" transform="translate(885.03 1844.547)" stroke-miterlimit="10"/><path pid="5" stroke-miterlimit="10" d="M879.544 1849.796h5.486"/></g></g>`
  }
})
/* tslint:enable */
